import { Component, OnInit, Input } from '@angular/core';
import { NewsService } from '../services/news.service';
import { News } from '../models/news.model';
import { SpinnerService } from '../services/spinner.service';



@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})

export class NewsComponent implements OnInit {

  @Input() home: boolean = false;
  selectedOptionFilter: string = '';
  public news = new Array<News>();
  public newsEnabled = new Array<News>();  
  public filteredNews = new Array();
  constructor(
    private newsService: NewsService,
    private spinnerService: SpinnerService,
  ) { }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.spinnerService.updatedState(true);
    this.newsService.getAll().subscribe(
      (data: Array<News>) => {
        console.log(data);
        this.spinnerService.updatedState(false);
        this.news = data;
        this.filteredNews = data;
        this.getEnabled();
        this.isHome();
     
      },
      (err) => {
        console.log(err);
        this.spinnerService.updatedState(false);
      }
    );
  }

  selectChangeHandler(event: any) {
    this.selectedOptionFilter = event.target.value;
    this.filteredNews = this.newsEnabled.filter(t => t.Category === this.selectedOptionFilter);
    if (this.selectedOptionFilter === "opcDesactivada" || this.selectedOptionFilter === "Todos") {
      this.filteredNews = this.newsEnabled;
    }
  }

  public isHome() {
    if(this.home && this.newsEnabled.length > 0) {
      // this.filteredNews = new Array(this.newsEnabled[this.newsEnabled.length - 1]);
      this.filteredNews = this.newsEnabled.slice(0 , this.newsEnabled.length - 3);
    }
  }

  public getEnabled() {
    this.newsEnabled = this.news.filter(
      (n: News) => { return n.Habilitada == true; }
    )
    this.filteredNews = this.newsEnabled;
  }


  //filteredNews: any[] = []; // Aquí almacenarás los elementos a mostrar después de aplicar filtros
  currentPage: number = 1; // Página actual
  itemsPerPage: number = 4; // Número de elementos por página

  // Método para obtener los elementos de la página actual
  getCurrentPageItems() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredNews.slice(startIndex, endIndex);
  }

  // Método para cambiar a la página siguiente
  nextPage() {
    if (this.currentPage < this.totalPages()) {
      this.currentPage++;
    }
  }

  // Método para cambiar a la página anterior
  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  // Método para calcular el número total de páginas
  totalPages() {
    return Math.ceil(this.filteredNews.length / this.itemsPerPage);
  }

}
